import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions';
import moment from 'moment';
import _ from 'lodash';
import PropTypes from 'prop-types';

class ChatFooter extends React.Component {

  constructor(props) {
    super(props);

    _.bindAll(this, 'typing', 'selectFile', 'sendButtonClicked', 'sendFileButtonClicked')
  }

  typing(e) {
    if (e.key == 'Enter') {
      e.preventDefault();
      this.sendRequest()
    }
  }

  sendButtonClicked(e) {
    e.preventDefault();
    this.sendRequest();
  }

  sendRequest() {
    const {sendMessage} = this.props;
    const inputs = this.refs.inputField.value;

    if (inputs.length > 0) {
      sendMessage({
        "type": "text",
        "isBot": false,
        "withIcon": true,
        "text": inputs,
        "time": moment().format('HH:mm')
      });
      this.refs.inputField.value = ""
    }
  }

  sendFileButtonClicked(e) {
    e.preventDefault();
    this.refs.fileUploadTag.click();
  }

  selectFile(e) {
    const {sendMessage} = this.props;
    var files = e.target.files || e.dataTransfer.files;
    const file = _.first(files);
    const url = URL.createObjectURL(file);
    switch (file.type) {
      case 'application/pdf':
      default:
        sendMessage({
          'type': 'normal-image',
          'isBot': false,
          'withIcon': true,
          'url': url,
          'time': '22:22'
        })
    }
    this.refs.inputField.value = ""
  }

  render() {
    return (
      <div className={'cu-ui-chat-footer'}>
        <form action=''>
          <div className={'cu-ui-form-group'}>
            <input ref={'inputField'} className={'cu-ui-input cu-ui-input-add-on'} type='text' onKeyPress={this.typing}/>
            <button className={'cu-ui-add-on cu-ui-button cu-ui-outline cu-ui-secondary'} onClick={this.sendFileButtonClicked}>
              <div className={'mdi mdi-plus-circle'}></div>
            </button>
            <input ref={'fileUploadTag'} type="file" accept="image/*, application/pdf" style={fileUploadTagStyle} onChange={this.selectFile} />
            <button className={'cu-ui-button cu-ui-button-lg cu-ui-primary'} onClick={this.sendButtonClicked}>
              Send
            </button>
          </div>
        </form>
      </div>
    )
  }
}

const fileUploadTagStyle = {
  display: "none"
};

const mapStateToProps = (state, props) => ({
  input_value: state.inputField.input_value
});

const mapDispatchToProps = (dispatch) => {
  return {
    sendMessage: bindActionCreators(actions.sendMessage, dispatch)
  };
};

ChatFooter.propTypes = {
  sendMessage: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(ChatFooter);


// WEBPACK FOOTER //
// ./src/components/chat-footer/index.jsx